import { z } from 'zod';
/**
 * Validates a ZIP code - must be either 5 digits or 9 digits (5+4 format)
 */
export const validateZipCode = (value) => {
    if (!value) {
        return true; // Let required validation handle empty values
    }
    const digits = value.replace(/\D/g, '');
    return digits.length === 5 || digits.length === 9;
};
export const addressValidationSchema = z.object({
    address: z.string().min(1, 'Address is required'),
    city: z.string().min(1, 'City is required'),
    state: z.string().min(2, 'State is required'),
    zipcode: z.string().min(1, 'Zip code is required').refine(validateZipCode, {
        message: 'ZIP code must be 5 digits or 9 digits (ZIP+4)',
    }),
});
export const addressOptionalValidationSchema = z.preprocess((raw) => {
    if (raw &&
        ['address', 'city', 'state', 'zipcode'].every((k) => {
            const v = raw[k];
            return v == null || (typeof v === 'string' && v.trim() === '');
        })) {
        return undefined;
    }
    return raw;
}, addressValidationSchema.optional());
